import { render, staticRenderFns } from "./kemptyplaceholder.vue?vue&type=template&id=401f5ef0&scoped=true&"
var script = {}
import style0 from "./kemptyplaceholder.vue?vue&type=style&index=0&id=401f5ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f5ef0",
  null
  
)

export default component.exports